import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getViewName } from 'design-comuni-plone-theme/components';
import { getUnibaBanner } from 'design-comuni-plone-theme/actions';
import { connect } from 'react-redux';
import 'react-loading-skeleton/dist/skeleton.css';
import HeaderBannerUnibaSkeleton from './HeaderBannerUnibaSkeleton';


class HeaderBannerUniba extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: '',
            imagesLoaded: false,
        };

        this.bannerRef = React.createRef();
    }

    componentDidMount() {
        this.props.getUnibaBanner();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.unibaBannerLoading &&
            !this.props.unibaBannerLoading &&
            this.props.unibaBannerResult
        ) {
            const { unibaBannerResult } = this.props;

            if ('url' in unibaBannerResult) {
                const footerEndpoint = getViewName(unibaBannerResult['url']);
                const fullEndpoint = `${window.location.origin}/++api++/${footerEndpoint}`;
                fetch(fullEndpoint)
                    .then((response) => response.text())
                    .then((html) => {
                        if (!html) {
                            this.setState({ content: null, imagesLoaded: true });
                        } else {
                            this.setState({ content: html, imagesLoaded: false }, this.waitForImages);
                        }
                    })
                    .catch((error) => console.error('Error fetching the UnibaBanner content:', error));
            } else if ('content' in unibaBannerResult) {
                this.setState({ content: unibaBannerResult['content'], imagesLoaded: false }, this.waitForImages);
            } else {
                this.setState({ content: null });
            }
        }
    }
    
    waitForImages = () => {
        const checkImages = () => {
            if (!container) return;

            const images = container.querySelectorAll('img');
            if (images.length === 0) {
                this.setState({ imagesLoaded: true });
                return;
            }

            let loadedCount = 0;
            const checkDone = () => {
                loadedCount++;
                if (loadedCount === images.length) {
                    this.setState({ imagesLoaded: true });
                }
            };

            images.forEach((img) => {
                if (img.complete) {
                    checkDone();
                } else {
                    img.onload = checkDone;
                    img.onerror = checkDone;
                }
            });
        };

        // delay to allow DOM to render
        setTimeout(checkImages, 0);
    };

    render() {
        const { content, imagesLoaded } = this.state;

        return (
            <div id="banner-uniba">
                {!imagesLoaded && <HeaderBannerUnibaSkeleton />}

                {content && (
                    <div
                        ref={this.bannerRef}
                        style={{
                            visibility: imagesLoaded ? 'visible' : 'hidden',
                            height: imagesLoaded ? 'auto' : 0,
                            overflow: 'hidden',
                        }}
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                )}
            </div>
        );
    }
}

HeaderBannerUniba.propTypes = {
    unibaBannerResult: PropTypes.object,
    unibaBannerLoading: PropTypes.bool,
    getUnibaBanner: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
    unibaBannerResult: state.unibaBanner.result,
    unibaBannerLoading: state.unibaBanner.loadingResults,
});

const mapDispatchToProps = {
    getUnibaBanner,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderBannerUniba);